import { memo } from 'react';
import { Star } from 'lucide-react';
import { RatingStarsProps } from '../types';

/**
 * Star rating component that allows setting a rating from 1-5
 */
export const RatingStars = memo(({
  rating,
  isVisited,
  isDisabled,
  onRatingChange
}: RatingStarsProps) => {
  const renderStar = (value: number) => {
    const isActive = rating >= value;
    
    return (
      <button
        key={value}
        type="button"
        disabled={!isVisited || isDisabled}
        onClick={() => onRatingChange(value)}
        className={`
          ${isVisited ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'}
          ${isDisabled ? 'pointer-events-none' : ''}
          transition-colors focus:outline-none
        `}
      >
        <Star
          className={`h-6 w-6 ${isActive ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`}
        />
      </button>
    );
  };

  return (
    <div className="flex items-center space-x-1">
      {[1, 2, 3, 4, 5].map(renderStar)}
    </div>
  );
});

RatingStars.displayName = 'RatingStars'; 